import { StateType } from 'data/types'

export const getCurrentSecondFactorChallenge = (state: StateType) =>
  state.auth.secondFactorChallenge.current
